import { useEffect, useRef, useState } from "react";
import { ReactComponent as ChevronDownIcon } from "../../../../../../../assets/icons/chevron-down.svg";
import { ReactComponent as CheckMarkIcon } from "../../../../../../../assets/icons/check-mark.svg";

const types = [{ label: "7 days", value: "7_days" }];

export function FilterSelect({ filter, setFilter, types, fieldName }) {
  const [showFilter, setShowFilter] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    // Implement outside click handler
    function handleClickOutside(event: MouseEvent) {
      if (
        containerRef.current &&
        !(containerRef.current as HTMLElement).contains(event.target as Node)
      ) {
        setShowFilter(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const selectedType = types.find((type) => type.value === filter[fieldName]);

  return (
    <div ref={containerRef} className="relative">
      <button
        type="button"
        onClick={() => setShowFilter((p) => !p)}
        className="justify-start w-fit min-w-[65px] !h-6 items-center gap-1 flex p-1.5 rounded border border-border-primary"
      >
        <div className="text-center flex-1 text-content-tertiary text-2xs font-medium leading-[11px]">
          {selectedType?.label}
        </div>
        <ChevronDownIcon
          className={`w-3 h-3 ${
            showFilter
              ? "rotate-180 pb-0.5 [&_path]:stroke-black"
              : "pt-0.5 [&_path]:stroke-neutral-600"
          }`}
        />
      </button>
      {showFilter && (
        <div className="absolute z-[1] left-0 mt-1 w-[126px] p-1 bg-surface-primary rounded shadow border border-border-secondary flex-col justify-start items-start gap-1.5 inline-flex">
          <div className="self-stretch max-h-[100px] flex-col justify-start items-start flex">
            {types.map((type) => (
              <button
                onClick={() =>
                  filter[fieldName] !== type.value &&
                  setFilter({ ...filter, [fieldName]: type.value })
                }
                type="button"
                key={type.value}
                className="self-stretch hover:bg-surface-secondary h-[25px] p-2 rounded-sm justify-between items-center inline-flex"
              >
                <div className="text-content-primary text-xs font-medium leading-3">
                  {type.label}
                </div>
                {filter[fieldName] === type.value && (
                  <CheckMarkIcon className="[[&_path]:stroke-primary_path]:stroke-brand-primary w-3 h-3" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}
